module.exports = __webpack_public_path__ + "static/media/scope.77a6f9b3.jpg";